import {Component, EventEmitter, Output} from '@angular/core';
import {MailForm} from '../mail-form';
import {Alert} from '../../../utils/alert';
import {ValidatorUtils} from '../../../utils/validator-utils';
import {UserService} from '../../../services/security/user.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent {

  @Output() cancel = new EventEmitter<void>();

  mailForm = MailForm.getForm();
  readonly MailForm = MailForm;

  displayErrorDynamic = false;
  loading = false;
  forgotIDSent = false;
  alert: Alert | undefined;

  constructor(
    private userService: UserService,
    public translateService: TranslateService
  ) {}

  sendMail() {
    if (this.loading) {
      return;
    }
    this.displayErrorDynamic = true;
    if (this.mailForm.valid) {
      this.loading = true;
      const mail = MailForm.getValue(this.mailForm);
      // @ts-ignore
      this.userService.sendResetPwdMail(mail.mail).subscribe(
        () => {
          this.forgotIDSent = true;
          this.loading = false;
        },
        () => this.loading = false
      );
    } else {
      this.alert = ValidatorUtils.getFormError(this.mailForm, MailForm.FIELDS.MAIL)
        .getAlert(Alert.Status.ERROR, this.translateService);
    }
  }

  backToLogin() {
    this.forgotIDSent = false;
    this.cancel.emit();
  }

  getError(): string | undefined {
    let error: string | undefined;

    if (this.displayErrorDynamic && this.mailForm.invalid && (this.mailForm.dirty || this.mailForm.touched)) {
      error = ValidatorUtils.getFormError(this.mailForm, MailForm.FIELDS.MAIL).getI18n(this.translateService);
    }
    if (error) {
      this.alert = undefined;
    }
    if (!error && this.alert) {
      error = this.translateService.instant(this.alert.detail.key, this.alert.detail.params);
    }
    return error;
  }
}
